import React from 'react';
import classes from './PercentTip.module.css';

const PercentTip = props => {
	let percentTip = null;
	if (props.percentChange) {
		percentTip = (
			<div className={classes.tooltipContainer}>
				<div className={props.percentChange >= 0 ? classes.tooltipGreen : classes.tooltipRed}>
					<div>{props.value}</div>
					<span className={classes.tooltiptext}>
						<div>{props.text}</div>
					</span>
				</div>
			</div>
		);
	} else if (props.pyme) {
		percentTip = (
			<div className={classes.tooltipContainer}>
				<div className={classes.tooltipPyme}>
					<div>{props.value}</div>
					<span className={classes.tooltiptext}>
						<div>{props.text}</div>
					</span>
				</div>
			</div>
		);
	} else if (props.corp) {
		percentTip = (
			<div className={classes.tooltipContainer}>
				<div className={classes.tooltipCorp}>
					<div>{props.value}</div>
					<span className={classes.tooltiptext}>
						<div>{props.text}</div>
					</span>
				</div>
			</div>
		);
	} else {
		percentTip = (
			<div className={classes.tooltipContainer}>
				<div className={classes.tooltipGrey}>
					<div>{props.value}</div>
					<span className={classes.tooltiptext}>
						<div>{props.text}</div>
					</span>
				</div>
			</div>
		);
	}

	return percentTip;
};

export default React.memo(PercentTip);
